import { render, staticRenderFns } from "./NbaBrowseTeam.vue?vue&type=template&id=2390affe&scoped=true"
import script from "./NbaBrowseTeam.vue?vue&type=script&lang=js"
export * from "./NbaBrowseTeam.vue?vue&type=script&lang=js"
import style0 from "./NbaBrowseTeam.vue?vue&type=style&index=0&id=2390affe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390affe",
  null
  
)

export default component.exports